<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            fab
            :small="$vuetify.breakpoint.smAndDown"
            :large="$vuetify.breakpoint.mdAndUp"
            depressed
            :color="isConnected ? 'red' : 'white'"
            :light="!isConnected"
            class="mx-3"
            @click="hangUp"
            v-bind="attrs"
            v-on="on"
            :loading="cancellingCall"
            >
            <v-icon>{{ isConnected ? 'mdi-phone-hangup' : 'mdi-close' }}</v-icon>
            </v-btn>
        </template>
        <span>{{ isConnected ? 'End call' : 'Close' }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'HangupButton',
    props: ['isConnected', 'cancellingCall'],
    methods: {
        hangUp () {
            this.$emit('hangUp')
        }
    }
}
</script>